import React, { createContext, useContext, useState } from 'react';

const EditWheelContext = createContext();

export const useEditWheelContext = () => {
    return useContext(EditWheelContext);
};

export const EditWheelProvider = ({ children }) => {
    const [editWheelData, setData] = useState(null);

    const setEditWheelData = (data) => {
        setData(data);
    };

    return (
        <EditWheelContext.Provider value={{ editWheelData, setEditWheelData }}>
            {children}
        </EditWheelContext.Provider>
    );
};
